<box class="product-request-type">
  <header>
      <box class="header-title">
          <!-- <span class="title">Who would you like to create the application for?</span> -->
          <span class="title">Application Initiation</span>
          <span class="caption">Please select one request type</span>
      </box>
      <fpx-button className="close" btnType="button" label="close" (onClick)="closeAlert()"></fpx-button>
  </header>

  <box class="actions-group">
      <fpx-button className="secondary" btnType="button" label="New Applicant" (onClick)="closeAlert('newApplicant')"></fpx-button>
      <fpx-button className="secondary" btnType="button" label="Existing Customer" (onClick)="closeAlert('existingCustomer')"></fpx-button>
  </box>

</box>
